var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Translate as T } from "react-localize-redux";
import { useCheckoutContext } from "../../../../../context/useCheckoutContext";
var useStyles = makeStyles(function (theme) { return ({
    body: {
        maxHeight: "calc(100% - " + theme.spacing(6) + "px)",
        overflowY: "auto",
    },
    close: {
        cursor: "pointer",
    },
    modal: {
        background: "#FFFFFF",
        height: "calc(100% - " + theme.spacing(8) + "px)",
        left: 0,
        padding: theme.spacing(4),
        position: "absolute",
        top: 0,
        width: "calc(100% - " + theme.spacing(8) + "px)",
        zIndex: 9999,
    },
    typography: __assign(__assign({}, theme.typography.h6), { color: "#293036", textAlign: "justify", whiteSpace: "pre-wrap", wordWrap: "break-word" }),
}); });
export var TermsModal = function (_a) {
    var setOpenTerms = _a.setOpenTerms;
    var classes = useStyles();
    var termsText = useCheckoutContext().termsAndConditions;
    return (React.createElement(Box, { className: classes.modal },
        React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", paddingBottom: 2 },
            React.createElement(Typography, { variant: "h4" },
                React.createElement(T, { id: "terms" })),
            React.createElement(CloseIcon, { className: classes.close, onClick: function () { return setOpenTerms(false); } })),
        React.createElement(Box, { className: classes.body },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: termsText }, className: classes.typography }))));
};
export default TermsModal;
